/**
 *
 * key
 *
 */

 const key = 'aW5wcm9ncmVzc0Nj'

 export default key
 